// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subcategory-centered-modal{top:50px;left:52px}@media(max-width: 767.98px){.subcategory-centered-modal{left:0}}", ""]);
// Exports
module.exports = exports;
